import React from 'react';
import { GlassPage } from '../components/chrome';

const SECTIONS = [
  {
    title: '1. Acceptance of Terms',
    body: (
      <p className="text-zinc-500 leading-relaxed">
        By accessing and using Korsa's website and services, you agree to be bound by these Terms of Service
        and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited
        from using or accessing this site.
      </p>
    )
  },
  {
    title: '2. Use License',
    body: (
      <>
        <p className="text-zinc-500 leading-relaxed">
          Permission is granted to temporarily access the materials on Korsa's website for personal,
          non-commercial transitory viewing only. This is the grant of a license, not a transfer of title,
          and under this license you may not:
        </p>
        <ul className="list-disc list-inside text-zinc-500 space-y-2 ml-4">
          <li>Modify or copy the materials</li>
          <li>Use the materials for any commercial purpose or public display</li>
          <li>Attempt to reverse engineer any software contained on Korsa's website</li>
          <li>Remove any copyright or proprietary notations from the materials</li>
        </ul>
      </>
    )
  },
  {
    title: '3. Product Information',
    body: (
      <p className="text-zinc-500 leading-relaxed">
        Korsa smart glasses are assistive technology devices designed to enhance communication.
        We strive to provide accurate product information, but we do not warrant that product descriptions,
        specifications, or other content is accurate, complete, reliable, current, or error-free.
      </p>
    )
  },
  {
    title: '4. Privacy & Data',
    body: (
      <p className="text-zinc-500 leading-relaxed">
        Your privacy is important to us. Our use of your personal information is governed by our Privacy Policy.
        By using our services, you consent to the collection and use of information as outlined in our Privacy Policy.
      </p>
    )
  },
  {
    title: '5. Pre-Orders',
    body: (
      <p className="text-zinc-500 leading-relaxed">
        Pre-order availability, pricing, and delivery dates are subject to change. By placing a pre-order,
        you agree that Korsa may modify specifications or features before the final product release.
        We will notify you of any significant changes to your pre-order.
      </p>
    )
  },
  {
    title: '6. Limitations',
    body: (
      <p className="text-zinc-500 leading-relaxed">
        Korsa or its suppliers will not be held liable for any damages arising out of the use or inability
        to use the materials on Korsa's website, even if Korsa or an authorized representative has been
        notified of the possibility of such damage.
      </p>
    )
  },
  {
    title: '7. Revisions',
    body: (
      <p className="text-zinc-500 leading-relaxed">
        Korsa may revise these Terms of Service at any time without notice. By using this website,
        you agree to be bound by the current version of these Terms of Service.
      </p>
    )
  },
  {
    title: '8. Governing Law',
    body: (
      <p className="text-zinc-500 leading-relaxed">
        These terms and conditions are governed by and construed in accordance with the laws of
        Massachusetts, United States, and you irrevocably submit to the exclusive jurisdiction of
        the courts in that location.
      </p>
    )
  },
  {
    title: '9. Contact Information',
    body: (
      <>
        <p className="text-zinc-500 leading-relaxed">
          If you have any questions about these Terms of Service, please contact us at:
        </p>
        <p className="text-zinc-900 font-bold">
          contact@korsa.tech
        </p>
      </>
    )
  }
];

const TermsOfService = () => {
  return (
    <GlassPage>
      {/* Hero Section */}
      <section className="relative flex flex-col justify-center px-6 md:px-12 pt-40 pb-12">
        <div className="max-w-4xl mx-auto w-full">
          <h1 className="text-[12vw] md:text-[6vw] font-bold leading-[0.9] tracking-tighter mb-8 uppercase text-zinc-900">
            Terms of<br/>Service
          </h1>
          <p className="text-sm text-zinc-400">
            Last Updated: January 2025
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-8 md:py-12 px-4 md:px-6">
        <div className="glass max-w-4xl mx-auto px-8 md:px-12 py-12 md:py-16 space-y-12">
          {SECTIONS.map((section) => (
            <div key={section.title} className="space-y-4">
              <h2 className="text-2xl md:text-3xl font-bold tracking-tighter uppercase text-zinc-900">
                {section.title}
              </h2>
              {section.body}
            </div>
          ))}
        </div>
      </section>
    </GlassPage>
  );
};

export default TermsOfService;
